export const contactConfig = {
  whatsapp: {
    number: "5547997270336",
    display: "+55 47 99727-0336",
  },

  instagram: {
    handle: "@nutri_nara_krause",
    href: "https://www.instagram.com/nutri_nara_krause/",
  },

  email: {
    value: "dionarakrausenutri@gmail.com",
    href: "mailto:dionarakrausenutri@gmail.com",
  },
  
  address: {
    full: "Blumenau - SC",
    mapsSearch:
      "https://www.google.com/maps/search/?api=1&query=Est%C3%A9tica%20Corporal%20e%20Facial%20%26%20Nutri%C3%A7%C3%A3o%20Dionara%20Krause%20Blumenau%20SC",
    mapsEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.0128466300853!2d-49.08315752368778!3d-26.903087392803375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94df1f57ce90b187%3A0x495a7aa2c6fc0f8f!2sEst%C3%A9tica%20Corporal%20e%20Facial%20%26%20Nutri%C3%A7%C3%A3o%20%E2%80%93%20Dionara%20Krause!5e0!3m2!1spt-BR!2sbr!4v1778443492408!5m2!1spt-BR!2sbr",
  },
};

export const whatsappMessages = {
  default:
    "Olá, tudo bem? Gostaria de saber mais sobre os atendimentos da Dionara.",

  scheduling:
    "Olá, tudo bem? Gostaria de agendar um atendimento com a Dionara.",

  nutrition:
    "Olá, tudo bem? Gostaria de saber mais sobre os acompanhamentos nutricionais.",

  aesthetics:
    "Olá, tudo bem? Gostaria de saber mais sobre os procedimentos estéticos.",

  services:
    "Olá, tudo bem? Gostaria de saber mais sobre os serviços da Dionara.",

  clinic:
    "Olá, tudo bem? Gostaria de saber mais sobre o espaço de atendimento.",

  aboutNutrition:
    "Olá, tudo bem? Gostaria de marcar uma consulta e saber mais sobre os acompanhamentos nutricionais da Dionara.",

  aboutAesthetics:
    "Olá, tudo bem? Gostaria de marcar um horário e saber mais sobre os procedimentos estéticos da Dionara.",

  aboutAll:
    "Olá, tudo bem? Gostaria de marcar uma consulta e saber mais sobre os atendimentos da Dionara.",
};

function normalizeWhatsAppNumber(number = "") {
  return String(number).replace(/\D/g, "");
}

function encodeMessage(message = "") {
  return encodeURIComponent(message.trim());
}

export function buildWhatsAppLink(message = whatsappMessages.default) {
  const number = normalizeWhatsAppNumber(contactConfig.whatsapp.number);

  return `https://wa.me/${number}?text=${encodeMessage(message)}`;
}

export function getWhatsAppMessageByKey(key = "default") {
  return whatsappMessages[key] || whatsappMessages.default;
}

export function getProcedureTypeLabel(type = "default") {
  const normalizedType = String(type || "").toLowerCase();

  if (normalizedType === "nutrition") {
    return "acompanhamento";
  }

  if (normalizedType === "aesthetics") {
    return "procedimento";
  }

  return "atendimento";
}

export function getProcedureWhatsAppMessage({
  title,
  type,
  action = "saber mais",
} = {}) {
  const serviceTitle = title || "esse atendimento";
  const typeLabel = getProcedureTypeLabel(type);

  if (action === "schedule") {
    return `Olá, tudo bem? Gostaria de agendar e saber mais sobre este ${typeLabel}: ${serviceTitle}.`;
  }

  return `Olá, tudo bem? Quero saber mais sobre este ${typeLabel}: ${serviceTitle}.`;
}

export function getProcedureWhatsAppLink({
  title,
  type,
  action = "schedule",
} = {}) {
  const message = getProcedureWhatsAppMessage({
    title,
    type,
    action,
  });

  return buildWhatsAppLink(message);
}

export function getAboutWhatsAppMessage(mode = "all") {
  const normalizedMode = String(mode || "all").toLowerCase();

  if (normalizedMode === "nutrition") {
    return whatsappMessages.aboutNutrition;
  }

  if (normalizedMode === "aesthetics") {
    return whatsappMessages.aboutAesthetics;
  }

  return whatsappMessages.aboutAll;
}

export function getAboutWhatsAppLink(mode = "all") {
  return buildWhatsAppLink(getAboutWhatsAppMessage(mode));
}

export function getBenefitsWhatsAppMessage(mode = "all") {
  const normalizedMode = String(mode || "all").toLowerCase();

  if (normalizedMode === "nutrition") {
    return "Olá, tudo bem? Gostaria de agendar uma consulta nutricional e entender melhor como funciona o acompanhamento com a Dionara.";
  }

  if (normalizedMode === "aesthetics") {
    return "Olá, tudo bem? Gostaria de agendar uma avaliação estética e saber mais sobre os procedimentos da Dionara.";
  }

  return "Olá, tudo bem? Gostaria de agendar uma avaliação e saber mais sobre os atendimentos da Dionara.";
}

export function getBenefitsWhatsAppLink(mode = "all") {
  return buildWhatsAppLink(getBenefitsWhatsAppMessage(mode));
}

export function getContactWhatsAppMessage(mode = "all") {
  const normalizedMode = String(mode || "all").toLowerCase();

  if (normalizedMode === "nutrition") {
    return "Olá, tudo bem? Gostaria de agendar uma consulta nutricional com a Dionara e saber mais sobre o acompanhamento.";
  }

  if (normalizedMode === "aesthetics") {
    return "Olá, tudo bem? Gostaria de agendar uma avaliação estética com a Dionara e saber mais sobre os procedimentos.";
  }

  return "Olá, tudo bem? Gostaria de agendar um atendimento com a Dionara e saber mais sobre os serviços.";
}

export function getContactWhatsAppLink(mode = "all") {
  return buildWhatsAppLink(getContactWhatsAppMessage(mode));
}


export function getPageHeroWhatsAppMessage(mode = "all", key = "scheduling") {
  const normalizedMode = String(mode || "all").toLowerCase();
  const normalizedKey = String(key || "scheduling").toLowerCase();

  if (normalizedKey === "services") {
    if (normalizedMode === "nutrition") {
      return "Olá, tudo bem? Gostaria de saber mais sobre os acompanhamentos nutricionais da Dionara.";
    }

    if (normalizedMode === "aesthetics") {
      return "Olá, tudo bem? Gostaria de saber mais sobre os procedimentos estéticos da Dionara.";
    }

    return "Olá, tudo bem? Gostaria de saber mais sobre os serviços da Dionara.";
  }

  if (normalizedKey === "clinic") {
    return "Olá, tudo bem? Gostaria de saber mais sobre o espaço de atendimento da Dionara.";
  }

  if (normalizedKey === "contact") {
    return getContactWhatsAppMessage(normalizedMode);
  }

  if (normalizedMode === "nutrition") {
    return "Olá, tudo bem? Gostaria de agendar uma consulta nutricional com a Dionara e entender melhor como funciona o acompanhamento.";
  }

  if (normalizedMode === "aesthetics") {
    return "Olá, tudo bem? Gostaria de agendar uma avaliação estética com a Dionara e saber mais sobre os procedimentos.";
  }

  return "Olá, tudo bem? Gostaria de agendar um atendimento com a Dionara e saber mais sobre os serviços.";
}

export function getPageHeroWhatsAppLink(mode = "all", key = "scheduling") {
  return buildWhatsAppLink(getPageHeroWhatsAppMessage(mode, key));
}